
const { ccclass, property, disallowMultiple, requireComponent, menu } = cc._decorator;

@ccclass
@disallowMultiple
@requireComponent(cc.Sprite)
@menu('Framework/UI组件/BaseStatePlusSprite')
export default class BaseStatePlusSprite extends cc.Component {

    @property
    _fillSpriteFrame: cc.SpriteFrame[] = [];
    @property({
        type: [cc.SpriteFrame]
        , displayName: '纹理组'
        , tooltip: '纹理组'
    })
    get fillSpriteFrame(){
        return this._fillSpriteFrame;
    }

    set fillSpriteFrame(value) {
        this._fillSpriteFrame = value;

        if (this.fillIndex >= value.length) {
            this.fillIndex = value.length-1;
        }
        this.refreshState();
    }

    @property
    _fillIdx: number = 0;
    @property({
        type: cc.Integer
        , displayName: '选择纹理'
        , tooltip: '选择纹理'
        , min: 0
    })  
    get fillIndex() {
        return this._fillIdx;
    }
    set fillIndex(value: number) {
        if (value < 0 || value >= this.fillSpriteFrame.length) {
            return;
        }
        this._fillIdx = value;
        this.refreshState();
    }

    private _defaultSprite: cc.Sprite = null;

    onLoad() {

    }

    protected resetInEditor() {
        this.init();
    }

    /**
     * 初始化
     */
    public init() {
        if (CC_EDITOR) {
            if (this.fillSpriteFrame.length <= 0) {
                let sprite = this.node.getComponent(cc.Sprite);
                this.fillSpriteFrame.push(sprite.spriteFrame);
            }
        }
    }

    start() {
        if (!this._defaultSprite) {
            this.setData();
        }
    }

    setData() {
        let sprite = this.node.getComponent(cc.Sprite);
        this._defaultSprite = sprite;
    }

    setFill(value: number) {
        // if (this._fillIdx == value) {
        //     return;
        // }
        this.fillIndex = value;
        this.refreshState();
    }

    refreshState() {
        if (!this._defaultSprite) {
            this.setData();
        }
        let idx = this._fillIdx;
        if (this._fillIdx >= this.fillSpriteFrame.length) {
            idx = this.fillSpriteFrame.length-1;
        }
        this._defaultSprite.spriteFrame = this.fillSpriteFrame[idx];
    }
}
